import React, { useEffect, useRef, useState } from "react";
import { TextField, Box } from "@material-ui/core";

export default function SpecifyDetail({
  show,
  savedValue = "",
  saveResponseDetail,
  questionType = ""
}) {
  const [value, setValue] = useState(savedValue);

  // Keep local state in sync with saved value from store when it changes
  useEffect(() => {
    setValue(savedValue ?? "");
  }, [savedValue]);

  const previousShowRef = useRef(show);

  // When the field hides (show goes from true -> false), clear the local UI value
  useEffect(() => {
    if (previousShowRef.current === true && show === false) {
      setValue("");
    }
    previousShowRef.current = show;
  }, [show]);

  // Do not persist on unmount; persistence happens on blur explicitly

  return show ? (
    <Box mt={questionType === "CannedSelect" ? 1 : -1} pl={6} display="flex">
      <TextField
        value={value}
        label="Specify"
        onChange={event => setValue(event.target.value)}
        onBlur={() => saveResponseDetail(value)}
        multiline
        style={{ width: "90%" }}
      />
    </Box>
  ) : null;
}
